/**
 * Textos da aba Documentos da mesa (E205.F4, ADR-0147 §2.5): tudo que o caso recebeu numa lista, com
 * o envio no alto, e "Informações da leitura" (a ficha), fora da mesa, no "Mais".
 */
export const ptBRDocumentos = {
  rotulo: 'Documentos do caso',
  envio: {
    titulo: 'Enviar documentos',
    texto: 'CCB, comprovante, documento de identidade e o que mais o caso pedir.',
    abrir: 'Enviar documentos',
    fechar: 'Fechar o envio',
  },
  lendo: 'Lendo os documentos do caso…',
  erro: 'Não foi possível listar os documentos do caso.',
  tentarDeNovo: 'Tentar de novo',
  vazio: 'O caso ainda não tem documento. Envie a CCB e o que mais o caso pedir.',
  colunas: {
    // E216.F3 (GUS-317 item 5): a mesma letra que o exame usa na seção 2
    letra: 'Letra',
    documento: 'Documento',
    papel: 'Papel',
    paginas: 'Páginas e leitura',
    custodia: 'Código declarado × custódia',
    acoes: 'Ações',
  },
  papel: {
    ccb: 'CCB',
    comprovante: 'Comprovante',
    laudo: 'Laudo',
    documento_de_identidade: 'Documento de identidade',
    // GUS-296 item 3: a fotografia eleita da comparação facial (a selfie da formalização).
    selfie: 'Selfie/FotoDocContrato',
    apoio: 'Documento de apoio',
    outro: 'Outro',
    arquivoUnico: 'Arquivo único',
  },
  paginas: '{n} páginas',
  umaPagina: '1 página',
  semPaginas: '—',
  leitura: {
    lida: 'Lida',
    imagem: 'Lida da imagem',
    leitura_pendente: 'Leitura em curso',
    leitura_com_falha: 'Leitura com falha',
    sem_texto: 'Imagem sem texto',
    fora_do_exame: 'Fora do exame',
    a_confirmar: 'Leitura a confirmar',
    confirmada: 'Leitura confirmada',
  },
  /** E216.F3: o arquivo que a seção 2 não lista, o excluído e o que falta ficam sem letra. */
  semLetra: '—',
  semCustodia: '—',
  acoes: {
    abrir: 'Abrir',
    abrirO: 'Abrir {nome} ao lado',
    baixar: 'Baixar',
    baixarO: 'Baixar {nome}',
    baixando: 'Baixando…',
    confirmar: 'Confirmar leitura',
    // E205.F4.C01 (F-E205.F4-01): o cartão continua alcançável depois de confirmar ou excluir.
    cartao: {
      confirmar: 'Confirmar leitura',
      revisar: 'Revisar leitura',
      exclusao: 'Exclusão da análise',
    },
    recolherConfirmacao: 'Recolher',
    // E209.F3.T06 (GUS-296 item 13a, texto do owner em 01/11): "Rever leitura" ficava ao lado de
    // "Revisar leitura" (o cartão de confirmação); esta abre o painel do dado lido.
    rever: 'Abrir o dado lido',
    reverO: 'Abrir o dado lido de {nome}',
  },
  // E205.F4.T03: o que não abre diz por quê.
  naoAbre: {
    tipo: 'Este tipo de arquivo não abre aqui. Baixe o original.',
    excluido: 'Excluído do caso.',
  },
  // E216.F4.C03 (GUS-317 P6): o arquivo excluído fica no fim da aba, sem letra, com o registro.
  excluido: {
    situacao: 'Excluído da análise. Para usar de novo, envie o arquivo por "Enviar documentos".',
    motivo: 'Motivo: {motivo}',
    porQuemQuando: 'Excluído por {quem} em {quando}',
    quando: 'Excluído em {quando}',
  },
  // O kit incompleto e a separação que falhou viram linhas da lista.
  kit: {
    falta: 'Falta no conjunto enviado',
    rotulo: '{tipo} (não recebido)',
  },
  arquivoUnico: {
    falhou: 'A separação não fechou',
  },
  enviar: 'Enviar documentos',
  // E205.F4.T05 (ADR-0147 §2.5): a ficha saiu da mesa e mora no "Mais".
  informacoes: {
    acao: 'Informações da leitura',
    titulo: 'Informações da leitura',
    texto:
      'O que a leitura achou em cada documento, de onde veio e o que não achou, para auditar. A correção de um campo é feita no documento, na mesa.',
    voltar: 'Voltar à mesa',
  },
} as const;
